'use strict';

/* jshint -W098 */
angular.module('mean.builders').controller('BuildersController', ['$scope', 'Global', 'Builders', 'Users', '$filter',
  function($scope, Global, Builders, Users, $filter) {
    $scope.global = Global;
    $scope.package = {
      name: 'builders'
    };
    
    $scope.onSelect = function() {
    	console.log('do some stuff here based on change in the selection box');

    };

    $scope.addBuilder = function(){
    	if (!$scope.name) $scope.name = [];

        var builder = new Builders({
            name: $scope.name
        });

        builder.$save(function(response) {
            $scope.name = response.name;
            $scope.builders.push(response);

            $scope.name = '';
            $scope.selectedItem = builder;
            $scope.onSelect();
        });
    };

    $scope.init = function() {
    	Users.query({ roles: 'builder' }, function(users) {
    		$scope.builder_users = $filter('filter')(users, { roles: 'builder' });
    	});

        Builders.query(function(builders) {
            if(builders)
              $scope.builders = builders;
        });
    };  

    $scope.update = function() {
    	console.log('update the builder information here' + $scope);
    	$scope.selectedItem.$update();
    };

    $scope.addDivision = function() {
    	$scope.selectedItem.division.push({
            name: '',
            address_one: '',
            address_two: '',
            city: '',
            state: '',
            zip: '',
            phone: '',
            email: '',
            builders: []
        });
    };

    $scope.removeDivision = function(idx) {
    	$scope.selectedItem.division.splice(idx,1);
    };

    $scope.addBuilderUser = function(index) {
    	$scope.selectedItem.division[index].builders.push('');
    	console.log('adding builder');
    };

    $scope.removeBuilderUser = function(index, idx) {
    	$scope.selectedItem.division[index].builders.splice(idx,1);
    	console.log('removing division');
    };

    $scope.states = [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'Florida',
        'Georgia',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
    ];
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/builders/public/controllers/builders.js